/**
 * Site maintenance toggle
 *
 * 1) Quick toggle: set MAINTENANCE_MODE_ENABLED to true/false below.
 * 2) Production / CI: set REACT_APP_MAINTENANCE_MODE=true in .env or hosting env
 *    (build-time; rebuild after changing).
 *
 * Env wins when set; otherwise the constant below is used.
 */
export const MAINTENANCE_MODE_ENABLED = false;

export function isMaintenanceMode() {
  const env = process.env.REACT_APP_MAINTENANCE_MODE;
  if (env !== undefined && env !== "") {
    return env === "true" || env === "1";
  }
  return MAINTENANCE_MODE_ENABLED;
}
